module.exports = __webpack_public_path__ + "photo-phone-sm.f1134bf186e1d44cd92a.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/assets/images/photo-phone-sm.jpg
// module id = ../../../../../src/assets/images/photo-phone-sm.jpg
// module chunks = main